var c = Object.defineProperty;
var i = (r, e, t) => e in r ? c(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var s = (r, e, t) => i(r, typeof e != "symbol" ? e + "" : e, t);
import { StepParamsObjectSchemaHandler as p } from "./step-params-object-schema-handler.js";
class g {
  constructor(e, t = []) {
    s(this, "isGenericTypeStepHandler", !0);
    s(this, "stepParamsObjectSchemaHandler");
    this.stepParamsObjectSchemaHandler = new p(
      e,
      [...t, "ofType", "namespace"]
    );
  }
  getFieldLogicLanguage(e, t) {
    return this.stepParamsObjectSchemaHandler.getFieldLogicLanguage(
      e,
      t
    );
  }
  getFieldLogicLanguageOptions(e, t) {
    return this.stepParamsObjectSchemaHandler.getFieldLogicLanguageOptions(
      e,
      t
    );
  }
  getFieldValue(e, t) {
    return this.stepParamsObjectSchemaHandler.getFieldValue(e, t);
  }
  get schema() {
    return this.stepParamsObjectSchemaHandler.schema;
  }
  getFields(e) {
    return this.stepParamsObjectSchemaHandler.getFields(e);
  }
  getUpdatedState(e, t, a) {
    return t === "ofType" ? {
      ...this.stepParamsObjectSchemaHandler.getUpdatedState(
        e,
        t,
        a
      ),
      ofType: a,
      namespace: ""
    } : this.stepParamsObjectSchemaHandler.getUpdatedState(
      e,
      t,
      a
    );
  }
  getUpdatedParamsConfigState(e, t, a, n) {
    return this.stepParamsObjectSchemaHandler.getUpdatedParamsConfigState(
      e,
      t,
      a,
      n
    );
  }
  validate(e) {
    return this.stepParamsObjectSchemaHandler.validate(e);
  }
  getInitialState(e, t) {
    const a = t && "isGenericTypeStepHandler" in t ? t.getOfTypeValue(e) : void 0;
    return {
      namespace: "",
      ...a && { ofType: a }
    };
  }
  getOfTypeValue(e) {
    return e.ofType;
  }
}
export {
  g as StepParamsGenericTypeHandler
};
